import { render } from "./GearLoadoutShowcase.vue?vue&type=template&id=597180c5"
import script from "./GearLoadoutShowcase.vue?vue&type=script&lang=js"
export * from "./GearLoadoutShowcase.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__